import { render } from "./AlbumsSection.vue?vue&type=template&id=b384683e&scoped=true"
import script from "./AlbumsSection.vue?vue&type=script&lang=js"
export * from "./AlbumsSection.vue?vue&type=script&lang=js"

import "./AlbumsSection.vue?vue&type=style&index=0&id=b384683e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b384683e"

export default script